const triggers = document.querySelectorAll('.tooltip-trigger');

triggers.forEach(trigger => {
  const tooltipId = trigger.getAttribute('aria-describedby');
  const tooltip = document.getElementById(tooltipId);
  const container = trigger.closest('.interactive-map-block'); // Parent container

  const closeAllTooltips = () => {
    triggers.forEach(otherTrigger => {
      const otherTooltipId = otherTrigger.getAttribute('aria-describedby');
      const otherTooltip = document.getElementById(otherTooltipId);

      otherTooltip.setAttribute('hidden', '');
      otherTrigger.setAttribute('aria-expanded', 'false');
      otherTooltip.classList.remove('__left'); // Remove modifier
    });
  };

  const isOverflowingContainer = () => {
    if (!container || !tooltip) return false;

    const containerRect = container.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();

    return (
      tooltipRect.right > containerRect.right ||
      tooltipRect.left < containerRect.left ||
      tooltipRect.top < containerRect.top ||
      tooltipRect.bottom > containerRect.bottom
    );
  };

  const toggleTooltip = () => {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      tooltip.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
      tooltip.classList.remove('__left');
    } else {
      closeAllTooltips();
      tooltip.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');

      // Wait for DOM to update, then check for overflow
      requestAnimationFrame(() => {
        if (isOverflowingContainer()) {
          tooltip.classList.add('__left');
        }
      });
    }
  };

  // Listeners
  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    toggleTooltip();
  });

  trigger.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleTooltip();
    }
  });
});

document.addEventListener('click', (event) => {
  triggers.forEach(trigger => {
    const tooltipId = trigger.getAttribute('aria-describedby');
    const tooltip = document.getElementById(tooltipId);

    const isClickInside = trigger.contains(event.target) || tooltip.contains(event.target);

    if (!isClickInside) {
      tooltip.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
      tooltip.classList.remove('__left');
    }
  });
});
